import { useState, useEffect, useContext } from "react";
import { Card, Table} from "react-bootstrap";
import { UserSettingsContext } from "../contexts/UserSettingsContext";
import authenticatedFetch from "./fetch"

import HubParticipation from "./HubParticipation";
import { cardOutlineStyle } from "./TaskCardParts";

const HubParticipationStatusTable = ({entityType, entityId, entityName, canEdit}) => {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [data, setData] = useState([]);

    const { tasksRefresh } = useContext(UserSettingsContext);
  
    useEffect(() => {
      reload();
    }, [entityType, entityId, entityName, tasksRefresh])
  
    function reload() {
      authenticatedFetch({
        path: entityType + "/participationstatus/hub/" + entityId,
        successHandler: function(result) {
          setIsLoaded(true);
          setData(result);
        },
        errorHandler: function(error) {
          setIsLoaded(true);
          setError(error);
        }
      });
    }
  
    var participationList;
  
    if (error)
    {
      participationList = <tr><td colSpan="5">Something went wrong... please reload the page...</td></tr>;
    }
    else if (!isLoaded)
    {
      participationList = <tr><td colSpan="5">Loading...</td></tr>;
    }
    else
    {
      participationList = data.hubs && data.hubs.length > 0
        && data.hubs.map((participation, i) => {
        return (
          <HubParticipation key={participation.id} onSave={reload} participationId={participation.id} entityType={entityType} entityId={entityId} entityName={entityName} participationName={participation.name} portal={participation.portalUrl} phone={participation.phone} email={participation.email} fax={participation.fax} effectiveDate={participation.effectiveDate} expires={participation.expires} canEdit={canEdit} />
        )
      }, this);
    }
    return (
      <Card style={cardOutlineStyle}>
        <Card.Header style={{paddingBottom: 8}}>
          <Card.Title as="h5" className="mb-0">Data Hub Access</Card.Title>
        </Card.Header>
        <Card.Body className="pt-0 pb-2">
        <Table striped hover size="sm" className="align-middle mb-0">
          <thead>
            <tr style={{fontSize: "0.7rem", letterSpacing: "0.06em", textTransform: "uppercase", color: "#8a929a"}}>
              <td>Name</td>
              <td>Portal</td>
              <td>Effective Date</td>
              <td>Next Attestation</td>
              <td>&nbsp;</td>
            </tr>
          </thead>
          <tbody style={{borderTopWidth: 1, borderTopColor: "#DCE5E3"}}>
            {participationList}
          </tbody>
        </Table>
        </Card.Body>
      </Card>
    );
  };

export default HubParticipationStatusTable;